import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';

import { Button } from '@pearsontechnology/aero-components';

import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';
import Modal, { ModalContent, ModalBodyText, ModalActions } from 'components/Modal';

import defaultMessages from './messages';

function DeleteConfirm({ visible, theme, onDismiss, messages, handleDeleteProject, ...props }) {
  return (
    <Modal
      title={messages ? intl.formatMessage(messages.modalConfirmationTitle) : intl.formatMessage(defaultMessages.modalConfirmationTitle)}
      icon="warningCircle"
      iconColor={theme['color.redLight']}
      onDismiss={onDismiss}
      visible={visible}
      theme={theme}
      {...props}
    >
      <ModalContent theme={theme}>
        <ModalBodyText theme={theme}>
          {messages ? intl.formatMessage(messages.modalConfirmationDescription) : intl.formatMessage(defaultMessages.modalConfirmationDescription)}
        </ModalBodyText>
      </ModalContent>
      <ModalActions theme={theme}>
        <Button theme={theme} grey onClick={onDismiss}>
          {messages ? intl.formatMessage(messages.cancel) : intl.formatMessage(defaultMessages.cancel)}
        </Button>
        <Button primary theme={theme} color={theme['color.redDark']} onClick={handleDeleteProject}>
          {messages ? intl.formatMessage(messages.deleteItem) : intl.formatMessage(defaultMessages.deleteItem)}
        </Button>
      </ModalActions>
    </Modal>
  );
}

DeleteConfirm.propTypes = {
  visible: PropTypes.bool.isRequired,
  theme: PropTypes.object,
  onDismiss: PropTypes.func,
  handleDeleteProject: PropTypes.func,
};

export default withTheme(DeleteConfirm);
